export const GET_EVENTS = "GET_EVENTS";
export const GET_EVENT_BY_ID = "GET_EVENT_BY_ID";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";
export const CREATE_EVENT = "CREATE_EVENT";
